<template>
  <div class="animated fadeIn" id="Hssk831-page-detail">
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-col md="12" class="text-center bold">
            <h5>CHỨNG NHẬN TIÊM CHỦNG - XÉT NGHIỆM</h5>
          </b-col>
          <b-col md="12">
            <div class="content">
              <el-button type="info" style="width: 200px; margin: auto" plain @click="openUrl()">
                {{ "Xem chứng nhận" }}
              </el-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mData: {
        url: "",
      },
    };
  },
  methods: {
    createIframe() {
      const dataUser = localStorage.getItem("dataUser");
      if (!dataUser) {
        this.$router.push({ name: "Auth-Page404" });
      }
      const dataUserObject = JSON.parse(dataUser);
      window.open(`${window.MyConfig.tiemChungUrl}?HO_TEN=${
        dataUserObject.FullName ? dataUserObject.FullName : ""
      }&SO_DIEN_THOAI=${
        dataUserObject.Phone ? "0" + dataUserObject.Phone.substring(2) : ""
      }`);
      this.mData.url = `${window.MyConfig.tiemChungUrl}?HO_TEN=${
        dataUserObject.FullName ? dataUserObject.FullName : ""
      }&SO_DIEN_THOAI=${
        dataUserObject.Phone ? "0" + dataUserObject.Phone.substring(2) : ""
      }`;
    },
    openUrl() {
        window.open(this.mData.url);
    }
  },
  mounted() {
    this.createIframe();
  },
};
</script>
<style scoped>
.content {
  width: 100%;
  height: calc(100vh - 140px);
  display: flex;
  justify-content: center;
  align-self: center;
  flex-direction: column;
}
</style>